import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { TraderPageResponse } from '../models/types'
import { traderQueryKeys } from '../keys'

const baseUrl = `${process.env.REACT_APP_API_URL}/v3/trader`

async function fetchTraderPage(name: string, page: number, size: number, signal?: AbortSignal) {
  const { data } = await axios.get<TraderPageResponse>(baseUrl, {
    params: { name: name || undefined, page, size },
    signal,
  })

  return data
}

export default function useTraderPageQuery(name: string, page: number, size: number) {
  return useQuery({
    queryKey: traderQueryKeys.page(name, page, size),
    queryFn: ({ signal }) => fetchTraderPage(name, page, size, signal),
    keepPreviousData: true,
  })
}
